// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  defaults: {
    VBtn: {
      style: "text-transform: none; font-weight: 700; letter-spacing: 0;",
      rounded: "lg",
    },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          // "Calm warmth" design system
          primary: "#EA6B26", // refined hero orange
          "primary-darken": "#D65B1B",
          accent: "#C2541A", // deep orange for links/labels
          background: "#FBF4EC", // warm cream base
          "background-darken": "#F6EADD", // soft sand band
          surface: "#FFFFFF",
          "on-background": "#2A2018",
          "on-surface": "#2A2018",
          secondary: "#3B2415", // cocoa anchor band
          tertiary: "#FBB040", // warm amber
          light: "#FBE3D2", // soft orange tint
          sun: "#FCE393",
          smoke: "#F1E7DC",
        },
      },
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
